import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/(public)/mcp-prawo/McpPageClient.tsx");
